/** The form element name for accessing its submission data */
export type FormElementKey = string
/** The submission data model to be submitted */
export type FormSubmissionModel = Record<FormElementKey, unknown>
